<template>
  <section>
    <div v-if="panel != 'tab-5'">
      <q-footer elevated>
        <q-toolbar>
          <div class="flex col-12 row items-center justify-between">
            <div class="col-8 div-progress q-pa-sm justify-center flex items-center">
              <q-linear-progress size="md" :value="progressBar" color="red-9" rounded />
            </div>
            <div class="col-4 justify-center flex items-center" v-if="panel == lowProductionController.tabEnd">
              <q-btn unelevated rounded color="red-9" @click="finishAttendance" :loading="isLoadingSubmit" :disable="isLoadingSubmit" label="Concluir" />
            </div>
            <div class="col-2 div-btn-next justify-center flex items-center" v-else>
              <q-btn round color="red-9" @click="addValueBarProgressAndAlterTab()" icon="arrow_forward" />
            </div>
          </div>
        </q-toolbar>
      </q-footer>
    </div>
  </section>

  <q-page-container>
    <q-page class="q-pa-md">
      <section class="section-service">
        <q-option-group hidden v-model="panel" inline :options="lowProductionController.listOfTabs" />

        <q-tab-panels v-model="panel" class="panel-services">
          <q-tab-panel name="tab-1" class="col-12 row items-center">
            <div class="col-12 row title-page">Dados do técnico</div>
            <div class="group-input col-12 row q-mt-lg">
              <label for="number_phone">Telefone (DDD + número)</label>
              <q-input :ref="refsFramework.numberPhoneRef" id="number_phone" class="col-12 q-mt-sm" bg-color="white"
                color="red-9" v-model="contract.numberPhone" dense outlined mask="(##) #####-####"
                placeholder="(##) #####-####" unmasked-value :rules="[
                  (val) => (val && val.length > 0) || 'Campo Obrigatório',
                  (val) =>
                    val.length > 10 || 'O número informado não parece valido.',
                ]" lazy-rules :disable="disableInputPhoneNumber">
                <template v-slot:after>
                  <q-btn round color="red-9" icon="edit" @click="disableInputPhoneNumberFunction" />
                </template>
              </q-input>
            </div>
            <div class="group-input col-12 row q-mt-lg">
              <label for="credenciada">Credenciada</label>
              <q-select id="accredited" :ref="refsFramework.accreditedRef" class="col-12 q-mt-sm" outlined dense
                v-model="contract.accredited" color="red-9" use-input hide-selected fill-input input-debounce="0"
                :options="optionsItens.optionsAccredited" option-value="value" option-label="text"
                @input-value="checkIsOwnTechnician"
                @filter="filterAccredited" bg-color="white" :rules="[(val) => val.length != '' || 'Campo Obrigatório']"
                lazy-rules :disable="disableInputAccredited">
                <template v-slot:no-option>
                  <q-item>
                    <q-item-section class="text-grey">
                      Sem resultado
                    </q-item-section>
                  </q-item>
                </template>
                <template v-slot:after>
                  <q-btn round color="red-9" icon="edit" @click="disableInputAccreditedFunction" />
                </template>
              </q-select>
            </div>
            <div>

            </div>
            <div class="col-12 column" v-if="hasTechinicanCodeOs">
              <div class="group-input col-12 column q-mt-lg">
                <label for="write-off-code">É tecnico próprio?</label>
                <div class="flex row justify-around">
                  <q-radio disable v-model="contract.isOwnTechnician" keep-color size="lg" :val="true" label="Sim"
                    color="red-6" />
                  <q-radio disable v-model="contract.isOwnTechnician" keep-color size="lg" :val="false" label="Não"
                    color="red-6" />
                </div>
              </div>
              <div class="group-input col-12 row q-mt-lg" v-show="contract.isOwnTechnician">
                <div class="col-12">
                  <label for="company_code">Código da Empresa</label>
                   <q-input :ref="refsFramework.technicianCodeRef" id="company_code" type="number" class="col-12 q-mt-sm" bg-color="white"
                      color="red-9" v-model="contract.technicianCode" dense outlined
                      unmasked-value :rules="[
                      (val) => (val && val.length > 0 || 
                      (!contract.isOwnTechnician || !hasTechinicanCodeOs)
                        ) || 'Campo Obrigatório',
                      ]" lazy-rules >
                    </q-input>
                </div>
              </div>
              <div class="group-input col-12 row q-mt-lg" v-show="!contract.isOwnTechnician">
                <div class="col-12">
                  <label for="atlas_code">Código do ATLAS</label>
                  <q-input :ref="refsFramework.accreditedCodeRef" type="number" id="atlas_code" class="col-12 q-mt-sm" bg-color="white"
                      color="red-9" v-model="contract.accreditedCode" dense outlined
                      unmasked-value :rules="[
                      (val) =>
                        (val && val.length > 0) ||
                        contract.isOwnTechnician ||
                        'Campo Obrigatório',
                      (val) =>
                        !val ||
                        !isNaN(Number(val)) ||
                        'Campo deve ser numérico',
                    ]" lazy-rules >
                    </q-input>
                </div>
              </div>
            </div>
          </q-tab-panel>

          <q-tab-panel name="tab-2" class="col-12 row items-center">
            <div class="col-12 row title-page">Dados do contrato</div>
            <div class="group-input col-12 row q-mt-lg flex justify-between">
              <div class="col-4">
                <label class="text-subtitle2" for="code_city">Cód. da Cidade</label>
                <q-select id="code_city" class="col-12 q-mt-sm" outlined dense :ref="refsFramework.codeCityRef"
                  v-model="contract.codeCity" color="red-9" @filter="filterCodCities" use-input hide-selected fill-input
                  input-debounce="0" :options="optionsItens.optionsCodCity" @update:model-value="handleChangeCityCode()"
                  option-value="value" option-label="value" bg-color="white"
                  :rules="[(val) => val.length != '' || 'Campo Obrigatório']" lazy-rules />
              </div>
              <div class="col-7">
                <label for="contract_number">Nº do Contrato</label>
                <q-input id="contract_number" :ref="refsFramework.contractNumberRef" v-model="contract.contractNumber"
                  class="col-4 q-mt-sm" bg-color="white" color="red-9" maxlength="10" dense outlined mask="##########"
                  unmasked-value placeholder="000000000" :rules="[(val) => val.trim() != '' || 'Campo Obrigatório']"
                  lazy-rules />
              </div>
            </div>
            <!-- <div class="col-12 group-input" v-if="parseInt(route.params.type_attendance) == GERAR_OS_REFAZER_DESOB">
              <label class="text-subtitle2" for="contract_wo">Número da WO</label>
              <q-input id="contract_wo" :ref="refsFramework.numberWo" v-model="contract.numberWo" class="col-4 q-mt-sm"
                bg-color="white" color="red-9" dense outlined />
            </div> -->
            <div class="group-input col-12 row q-mt-md">
              <label for="city">Cidade</label>
              <q-select id="city" class="col-12 q-mt-sm" outlined dense :ref="refsFramework.cityRef"
                v-model="contract.city" color="red-9" @filter="filterCities" use-input hide-selected fill-input
                input-debounce="0" :options="optionsItens.optionsCity" option-value="value" option-label="text"
                bg-color="white" :rules="[(val) => val.length != '' || 'Campo Obrigatório']" lazy-rules />
            </div>
          </q-tab-panel>

          <q-tab-panel name="tab-3" class="col-12 row items-center">
            <div class="col-12 row title-page flex justify-between">
              solicitações
              <span>Tempo para tabular {{ timerAttendance.timer }}</span>
            </div>
            <div class="div-requests col-12 row flex">
              <card-requests-os v-for="item in contract.osRequests" :check="item.check" :os-number="item.osNumber"
                :type-os="item.typeOS" :key="item.onject_id" :redo-from-drop="item.redoFromDrop"
                @edit="editSchemaRequest(item)" @openConfirm="
                  modalDialogConfirmarDeleteSchemaOsRequest(
                    item.object_id,
                    item.osNumber
                  )
                  " />
            </div>
            <div class="col-12 row flex justify-end q-mt-md">
              <q-btn unelevated text-color="red-9" @click="addNewSchemaRequest" size="md" icon="add"
                label="Nova solicitação" />
            </div>
          </q-tab-panel>

          <q-tab-panel name="tab-4" class="col-12 row items-center">
            <div class="col-12 row title-page">Informações finais</div>

            <div class="col-12 row q-mt-sm">
              <label>Insira os horários de início e conclusão do atendimento.</label>
            </div>
            <div class="col-12 q-mt-lg">
              <label for="start">Início</label>
              <q-input id="start" :ref="refsFramework.initialTimeRef" v-model="contract.initialTime" bg-color="white"
                class="col-12 q-mt-sm" color="red-9" type="time" dense outlined
                :rules="[(val) => val.length != '' || 'Campo Obrigatório']" lazy-rules @update:model-value="validateTime"
                />
            </div>
            <div class="col-12 q-mt-lg">
              <label for="conclusion_time">Conclusão</label>
              <q-input id="conclusion_time" :ref="refsFramework.conclusionTimeRef" v-model="contract.conclusionTime"
                bg-color="white" class="col-12 q-mt-sm" color="red-9" type="time" dense outlined
                :rules="[(val) => val.length != '' || 'Campo Obrigatório']" lazy-rules @update:model-value="validateTime" :disable="!contract.initialTime" />
            </div>
          </q-tab-panel>

          <q-tab-panel name="tab-5" class="col-12 row items-center">

            <FormOsDesobstructionRequest v-if="parseInt(route.params.type_attendance) == GERAR_OS_REFAZER_DESOB"
              :itemOsContract="itemOsContract" :listWriteOffCode="listWriteOffCode" 
              :citySelected="contract.city"
              @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)" 
              @clearSchemaRequest="(requestData) => clearSchemaRequest(requestData)" 
            />
            
            <FormOsLowProductionWithoutMove v-else-if="parseInt(route.params.type_attendance) == BAIXA_PRODUTIVA_COM_MOVIMENTACAO"
              :itemOsContract="itemOsContract" 
              :optionsWriteOffCode="optionsItens.optionsWriteOffCode"
              :optionsTypeOS="optionsItens.optionsTypeOS" 
              :listWriteOffCode="listWriteOffCode"
              :listTypeOS="listTypeOSFixed" 
              @selectTypeOs="getByTypeOs"
              :optionsTypeOSByClassification="listTypeOSByClassification"
              :optionsActionOs="listActionOs" :optionsStateEquipaments="listEquipamentsOS" @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)
                " @clearSchemaRequest="clearSchemaRequest" @removeEdit="() => returnSolicitationTab()" />
            

            <FormOsProductionRquest v-else :itemOsContract="itemOsContract"
              :optionsWriteOffCode="optionsItens.optionsWriteOffCode" :optionsTypeOS="optionsItens.optionsTypeOS"
              :listWriteOffCode="listWriteOffCode" :listTypeOS="listTypeOS" @saveSchemaRequest="(requestData) => saveSchemaRequest(requestData)
                " @clearSchemaRequest="clearSchemaRequest" @onTypeOsChange="getWriteOffCodeByAttendance" />
                
          </q-tab-panel>
        </q-tab-panels>
      </section>
    </q-page>
  </q-page-container>
</template>

<script setup>
import CardRequestsOs from "@/components/CardRequestsOs";
import FormOsDesobstructionRequest from "@/components/RequestOsForms/FormOsDesobstructionRequest";
import FormOsLowProductionWithoutMove from "@/components/RequestOsForms/FormOsLowProductionWhitoutMove.vue";
import FormOsProductionRquest from "@/components/RequestOsForms/FormOsProductionRquest";
import moment from "moment-timezone";
import { useQuasar } from "quasar";
import { computed, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import LowProductionServices from "../../services/LowProductionServices";

import { validateConclusionTime } from "@/helpers/conclusionTimeHelper";
import { showNotifyError } from "@/helpers/notifyHelper";
import { timeToMinutes } from "@/helpers/timeToMinutesHelper";
import LowProductionController from "@/pages/TabulationsPages/lowProductionController.js";
import { BAIXA_IMPRODUTIVA, BAIXA_PRODUTIVA_COM_MOVIMENTACAO, BAIXA_PRODUTIVA_SEM_MOVIMENTACAO, GERAR_OS_REFAZER_DESOB } from "@/utils/constants/typeOs/lowProduction.js";
import createJsonProductionOsRequest from "../../utils/ResquestOsForms/createJsonOsRequest";
import createJsonDesobstructionOsRequest from "../../utils/ResquestOsForms/createJsonOsRequestDesobstruiction";
import createJsonOsRequestWithMovimentation from "../../utils/ResquestOsForms/createJsonOsRequestWithMovimentation";
import getTypeOSnameById, {
  getTypeLow
} from "../../utils/ResquestOsForms/getTypeOSnameById";

const $q = useQuasar();
const router = useRouter();
const route = useRoute();
const store = useStore();
const lowProductionServices = new LowProductionServices();
const citiesAvailable = ["235", "487"];
const lowProductionController = new LowProductionController(route.params.type_attendance);

let progressBar = ref(lowProductionController.progressBarIncrement);
let tabindex = ref(1);
let panel = ref("tab-1");
let confirmationReplicateWriteOffCode = ref(false);
let modalReplicateWriteOffCode = ref(false);
let writeOffCodeDefault = ref("");
let disableInputPhoneNumber = ref(false);
let disableInputAccredited = ref(false);
let inputTeamVisible = computed(
  () =>
    contract.accredited == "TECNICO PROPRIO" ||
    contract.accredited.value == "TECNICO PROPRIO"
);
let escalation = ref({});
const listCities = ref([]);
const listTypeOS = ref([]);
const listTypeOSFixed = ref([]);
const listTypeOSByClassification = ref([]);
const listActionOs = ref([]);
const listEquipamentsOS = ref([]);
const listWriteOffCode = ref([]);
const listAccrediteds = ref([]);
//TESTE DE GUARULHOS
const isTypeAttendanceLowProduction = ref(route.params.type_attendance == BAIXA_PRODUTIVA_COM_MOVIMENTACAO);
const isWriteOffByTypeAttendance = ref(route.params.type_attendance == BAIXA_PRODUTIVA_SEM_MOVIMENTACAO || route.params.type_attendance == BAIXA_IMPRODUTIVA);
const typeAttendance = route.params.type_attendance;
const hasTechinicanCodeOs = [BAIXA_PRODUTIVA_SEM_MOVIMENTACAO, BAIXA_IMPRODUTIVA].includes(Number(route.params.type_attendance));

const isLoadingSubmit = ref(false);
const toggleLoadingSubmit = () => (isLoadingSubmit.value = !isLoadingSubmit.value);

const defaultTimesMapper = {
    4: { minutes: 4, timer: "04:00" },
    default: { minutes: 10, timer: "10:00" },
  };

function createTimerConfig(typeAttendance) {

  const { minutes, timer } = defaultTimesMapper[typeAttendance] || defaultTimesMapper.default;

  return reactive({
    minutes,
    seconds: 0,
    timer,
    stopTime: false,
  });
};

const timerAttendance = createTimerConfig(typeAttendance);

let setIntervat;
let excute = ref(true);
let team = ref("");

let contract = reactive({
  accredited: "",
  city: "",
  numberPhone: "",
  codeCity: "",
  initialTime: typeAttendance == GERAR_OS_REFAZER_DESOB ? moment().tz("America/Sao_Paulo").format("HH:mm") : "",
  conclusionTime: "",
  contractNumber: "",
  isOwnTechnician: true,
  accreditedCode: "",
  technicianCode: "",
  serviceOutsideToa: 0,
  dateStartedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
  dateFinishedAttendance: "",
  numberWo: "",
  osRequests: [],
});

let itemOsContract = reactive({
  data: {},
});

let refsFramework = {
  teamRef: ref(""),
  numberPhoneRef: ref(""),
  accreditedRef: ref(""),
  codeCityRef: ref(""),
  contractNumberRef: ref(""),
  cityRef: ref(""),
  typeOSRef: ref(""),
  osNumberRef: ref(""),
  writeOffCodeRef: ref(""),
  conclusionTimeRef: ref(""),
  initialTimeRef: ref(""),
  numberWo: ref(""),
  accreditedCodeRef: ref(""),
  technicianCodeRef:ref("")
};

const optionsItens = reactive({
  optionsAccredited: listAccrediteds.value,
  optionsCity: listCities.value,
  optionsCodCity: listCities.value,
  optionsTypeOS: listTypeOS.value,
  optionsWriteOffCode: listWriteOffCode.value,
});

const lowTypeFilteredByCity = [BAIXA_IMPRODUTIVA];
const currentTypeId = parseInt(route.params.type_attendance);

function startTimerFilledRequest() {
  if (!timerAttendance.stopTime) {
    setIntervat = setInterval(() => {
      if (route.name != "low-production") {
        clearInterval(setIntervat);
        return;
      }
      if (tabindex.value != 3 && tabindex.value != 5) {
        return;
      }
      if (timerAttendance.seconds > 0) {
        timerAttendance.seconds--;
      } else {
        if (timerAttendance.minutes > 0) {
          timerAttendance.minutes--;
          timerAttendance.seconds = 60;
        }
      }
      if (timerAttendance.seconds == 0 && timerAttendance.minutes == 0) {
        _modalDialogConfirmRedirectByTimeoutDefaultRequest();
      }
      setTimer(timerAttendance.minutes, timerAttendance.seconds);
    }, 1000);
  }
}

function setTimer(minutes, seconds) {
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  timerAttendance.timer = minutes + ":" + seconds;
}

function openConfirmationReplicateWriteOffCode() {
  if (requestData.writeOffCode == "") {
    confirmationReplicateWriteOffCode.value = false;
    showNotifyError("Selecione um código baixa antes de replicar.");
    return;
  }

  if (confirmationReplicateWriteOffCode.value == true) {
    modalReplicateWriteOffCode.value = true;
  } else {
    cancelReplicate();
  }
}

function replicateWriteOffCode() {
  for (let item of contract.osRequests) {
    if (item.osNumber !== requestData.osNumber && item.replicate === true) {
      item.writeOffCode = requestData.writeOffCode;
    }
  }
  confirmationReplicateWriteOffCode.value = true;
  modalReplicateWriteOffCode.value = false;
}

function cancelReplicate() {
  confirmationReplicateWriteOffCode.value = false;
  for (let item of contract.osRequests) {
    item.replicate = false;
  }
}

function _getCitiesActives() {
  lowProductionServices.getCitiesActives().then((response) => {
    listCities.value = response;
  }).catch((err)=>{
    console.log(err);
  });
}

function _getTypeOsActives() {
  lowProductionServices.getTypeOsByServiceOption("1").then((response) => { });
};

async function getLowTypes(){
 if(!lowTypeFilteredByCity.includes(currentTypeId)){
  let typeOs = getTypeOSnameById(route.params.type_attendance);

     lowProductionServices.getLowType(typeOs).then((response) => {
      listTypeOSFixed.value = response;
      listTypeOS.value = response;
    });
  }
}

async function getTypeOsByClassification() {
  _getWriteOffCodeActives();

  await lowProductionServices
    .getTypeOsClassificationByCity()
    .then((response) => {
      
      console.log(response)
      listTypeOSByClassification.value = response;
    });
}

function _getAllActions() {
  lowProductionServices.getAllActions().then((response) => {
    listActionOs.value = response;
  });
}

function _getAllStateEquipaments() {
  lowProductionServices.getAllStateEquipaments().then((response) => {
    listEquipamentsOS.value = response;
  });
}

function _getWriteOffCodeActives(actionId = null) {
  let idTipoBaixa = getTypeLow(route.params.type_attendance, actionId)

  lowProductionServices
    .getWriteOffCodeByLowType(idTipoBaixa)
    .then((response) => {
      listWriteOffCode.value = response;
    });
};

function getWriteOffCodeByTypeOS(typeOs) {
  lowProductionServices.getWriteOffCodeByTypeOs(typeOs).then((response) => {
    listWriteOffCode.value = response;
  });
}

function getWriteOffCodeByAttendance(typeOs) {
  let typeAttendance = route.params.type_attendance;

  lowProductionServices.getWriteOffCodeByTypeOsAndTypeAttendance(typeOs.value, typeAttendance).then((response) => {
    listWriteOffCode.value = response;
  });
}

function getByTypeOs(typeOs){
  getWriteOffCodeByTypeOS(typeOs);
}

function _getAccreditedsActives() {
  lowProductionServices.getAccreditedsActives().then((response) => {
    listAccrediteds.value = response;
  });
};

function getLowTypeByCityCode(){
  let typeOs = getTypeOSnameById(route.params.type_attendance);
  lowProductionServices.getLowTypeByCityCode(typeOs, contract.codeCity.value).then((response) => {
  listTypeOSFixed.value = response;
  listTypeOS.value = response;
  });
}

function getCityByCodeCity() {
  lowProductionServices
    .getCityByCodeCity(contract.codeCity.value)
    .then((response) => {
      contract.city = {
        text: response.cidade,
        value: response.codcidadenetsms,
      };
    });
}

function handleChangeCityCode(){
  getCityByCodeCity();

  if(lowTypeFilteredByCity.includes(currentTypeId)){
    getLowTypeByCityCode();
  }

}

function addValueBarProgressAndAlterTab() {
  const VALUE_MAX_BAR_PROGRESS = 1;
  const VALUE_ADD_PROGRESS = lowProductionController.progressBarIncrement;
  if (progressBar.value != VALUE_MAX_BAR_PROGRESS) {
    let validateIfChangeTab = _changeTab();
    if (validateIfChangeTab) {
      progressBar.value += VALUE_ADD_PROGRESS;
    }
  }
}

function returnSolicitationTab() {
  const VALUE_MIN_BAR_PROGRESS =lowProductionController.progressBarIncrement;
  const VALUE_REMOVE_PROGRESS = lowProductionController.progressBarIncrement;
  const VALUE_TAB_INDEX = 2;

  if (progressBar.value > VALUE_MIN_BAR_PROGRESS) {
    tabindex.value -= VALUE_TAB_INDEX;
    panel.value = "tab-" + tabindex.value;
    //progressBar.value -= VALUE_REMOVE_PROGRESS;
  }
}

function _changeTab() {
  const VALUE_INCREMENT_ID_TAB = 1;
  const STRING_ID_TAB = "tab-";
  // const TAUBATE_CITY = "235";

  let validateFieldsFilled = _validateFieldsTabs(tabindex.value);
  if (validateFieldsFilled) {
    if (
      tabindex.value == 1 &&
      (!disableInputPhoneNumber.value ||
        !disableInputAccredited.value ||
        team.value != store.state.team)
    ) {
      
      if (store.state.numberPhone == "") {
        _saveTechnicianPhoneNumberAndAccredited();
      } else {
        _editTechnicianPhoneNumberAndAccredited();
      }
    }

    if (tabindex.value == 2) {
      startTimerFilledRequest();
    }

    if (tabindex.value == 3) {
      contract.dateFinishedAttendance = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");
      timerAttendance.stopTime = true;
    };

    tabindex.value += VALUE_INCREMENT_ID_TAB;
    panel.value = STRING_ID_TAB + tabindex.value;

    return true;
  }
}

function _editTechnicianPhoneNumberAndAccredited() {
  let TechnicianData = {
    login_tecnico: store.state.technicianLogin.toString(),
    telefone: contract.numberPhone,
    equipe: team.value,
    credenciada:
      contract.accredited.value == null
        ? contract.accredited
        : contract.accredited.value,
  };
  lowProductionServices.editTechnicianPhoneNumberAndAccredite(TechnicianData);
}

function _saveTechnicianPhoneNumberAndAccredited() {
  let TechnicianData = {
    login_tecnico: store.state.technicianLogin,
    telefone: contract.numberPhone,
    credenciada: contract.accredited.value,
    nome_tecnico: store.state.technicianName,
    equipe: team.value,
  };
  lowProductionServices.saveTechnicianPhoneNumberAndAccredite(TechnicianData);
}

function _validateFieldsTabs(tabindex) {
  
  if (tabindex == 1) {
    if (hasTechinicanCodeOs) {
      if (
        !refsFramework.numberPhoneRef.value.validate() ||
        !refsFramework.accreditedRef.value.validate() ||
        !refsFramework.accreditedCodeRef.value.validate() ||
        !refsFramework.technicianCodeRef.value.validate()
      ) {
        return false;
      }
      return true;
    }
    if (
      !refsFramework.numberPhoneRef.value.validate() ||
      !refsFramework.accreditedRef.value.validate() 
    )
      return false;
    return true;
  }
  if (tabindex == 2) {
    var regexContract = /^(\d)\1+$/;
    var regexWo = /^(\d+)|(\d+)$/;

    if (
      !refsFramework.codeCityRef.value.validate() ||
      !refsFramework.contractNumberRef.value.validate() ||
      !refsFramework.cityRef.value.validate()
    )
      return false;

    if (regexContract.test(contract.contractNumber)) {
      showNotifyError("O número de contrato não poder ter uma cadeia do mesmo caracter.");
      return false;
    }

    // if (parseInt(route.params.type_attendance) == GERAR_OS_REFAZER_DESOB) {
    //   if (!refsFramework.numberWo.value.validate()) return false;

    //   if (contract.numberWo != "") {
    //     if (!regexWo.test(contract.numberWo)) {
    //       showNotifyError("O número da WO permite apenas números e |.");
    //       return false;
    //     }
    //   }
    // }

    return true;
  }
  if (tabindex == 3) {
    let checkRequestChecked = false;
    for (let obj of contract.osRequests) {
      if (!obj.check) {
        checkRequestChecked = false;
        showNotifyError("Não é possivel continuar sem ter no mínimo uma solicitação devidamente preenchida.");
        return;
      } else {
        checkRequestChecked = true;
      }
    }
    return checkRequestChecked;
  }
  if (tabindex == 4) {
    let hoursNow = new Date().getHours();
    let conclusionTimeHours = contract.conclusionTime.split(":")[0];
    let initialTimeHours = contract.initialTime.split(":")[0];

    if (conclusionTimeHours > hoursNow || initialTimeHours > hoursNow) {
      showNotifyError("Não é permitido selecionar uma hora futura.");
      return false;
    }

    if (
      !refsFramework.conclusionTimeRef.value.validate() ||
      !refsFramework.initialTimeRef.value.validate()
    )
      return false;
    return true;
  }
}

function filterAccredited(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsAccredited = listAccrediteds.value.filter(
      (v) => v.text.toLowerCase().indexOf(needle) > -1
    );
  });
}

function filterCities(val, update) {
  update(() => {
    if (val === "") {
      optionsItens.optionsCity = listCities.value;
      return;
    }
  });

  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsCity = listCities.value.filter(
      (v) => v.text.toLowerCase().indexOf(needle) > -1
    );
  });
}

function filterCodCities(val, update) {
  update(() => {
    const needle = val.toLowerCase();
    optionsItens.optionsCodCity = listCities.value.filter(
      (v) => v.value.toLowerCase().indexOf(needle) > -1
    );
  });
}

function editSchemaRequest(item) {
  panel.value = "tab-5";
  tabindex.value = 5;
  itemOsContract.data = item;
}

function clearSchemaRequest(object = null) {
  if (object !== null) {
    deleteSchemaRequest(object.object_id);
    object.redoFromDrop = true;
    contract.osRequests.push(object);
  }
  panel.value = "tab-3";
  tabindex.value = 3;
}

function _createInitSchemaRequest() {
  for (const item of store.state.osNumbers.split(",")) {
    let schemaRequest = {
      object_id: _generateUUIDv4(),
      osNumber: item,
      typeOS: "",
      statusOS: 1,
      writeOffCode: writeOffCodeDefault == "" ? "" : writeOffCodeDefault,
      observation: "",
      check: false,
      replicate: false,
      source: "NetSMS",
      redoFromDrop: false,
    };
    contract.osRequests.push(schemaRequest);
  }
}

function deleteSchemaRequest(object_id) {
  let newObjectOSRequest = contract.osRequests.filter((obj) => {
    return obj.object_id != object_id;
  });

  contract.osRequests = newObjectOSRequest;
}

function saveSchemaRequest(requestData) {
  deleteSchemaRequest(requestData.object_id);
  contract.osRequests.push(requestData);
  clearSchemaRequest();
}

function addNewSchemaRequest() {
  let schemaRequest = {
    object_id: _generateUUIDv4(),
    osNumber: "",
    typeOS: "",
    statusOS: 1,
    writeOffCode: writeOffCodeDefault == "" ? "" : writeOffCodeDefault,
    observation: "",
    check: false,
    replicate: false,
    source: "Vega",
    redoFromDrop: false,
  };

  contract.osRequests.push(schemaRequest);
}

async function finishAttendance() {
  toggleLoadingSubmit();
  contract.dateFinishedAttendance = moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss");
  if (typeAttendance == 13) {
    contract.conclusionTime = moment().tz("America/Sao_Paulo").format("HH:mm");
    delete contract.dateStartedAttendance;
  }

  if (!_validateFieldsTabs(tabindex.value)) return false;

  _createJsonOsRequestFinishAttendance();
  
  await lowProductionServices
    .finishService(contract)
    .then((response) => {
      let token = localStorage.getItem("access_token");
            router.replace({
              name: "service-history",
              query: { access_token: token },
            });
            toggleLoadingSubmit();
    })
    .catch((error) => {
       $q.notify({
        message: `Erro ao salvar requisição`,
        position: "top",
        timeout: 2000,
        color: "red-9"
      })
      setTimeout(() => {
        let token = localStorage.getItem("access_token");
            router.replace({
              name: "service-history",
              query: { access_token: token },
            });
            toggleLoadingSubmit();
      }, "1000");
    });
}

function _createJsonOsRequestFinishAttendance() {
  let ATTENDANCE_LOW_PRODUCTIVE = parseInt(route.params.type_attendance);
  let createJsonOsRequest = null;

  contract.codeCity = contract.codeCity.value;
  contract.typeAttendance = ATTENDANCE_LOW_PRODUCTIVE;
  (contract.accredited =
    contract.accredited.value == null
      ? contract.accredited
      : contract.accredited.value),
  delete contract.city;
  
  if (
    ATTENDANCE_LOW_PRODUCTIVE == BAIXA_PRODUTIVA_SEM_MOVIMENTACAO ||
    ATTENDANCE_LOW_PRODUCTIVE == BAIXA_IMPRODUTIVA
  ) {
    createJsonOsRequest = createJsonProductionOsRequest;
  }

  if (ATTENDANCE_LOW_PRODUCTIVE == BAIXA_PRODUTIVA_COM_MOVIMENTACAO) {
    createJsonOsRequest = createJsonOsRequestWithMovimentation;
  }

  if (ATTENDANCE_LOW_PRODUCTIVE == GERAR_OS_REFAZER_DESOB) {
    createJsonOsRequest = createJsonDesobstructionOsRequest;
  }

  for (let i = 0; i < contract.osRequests.length; i++) {
    contract.osRequests[i] = createJsonOsRequest(contract.osRequests[i], contract);
  }

}

function _generateUUIDv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

function modalDialogConfirmarDeleteSchemaOsRequest(object_id, osNumber) {
  $q.dialog({
    title: `Deletar OS ${osNumber}`,
    message: `Atenção! Após deletar a OS, não há uma forma de reverter. Tem certeza que deseja deletar a OS selecionada?`,
    cancel: true,
    persistent: true,
    position: "bottom",
  })
    .onOk(() => {
      deleteSchemaRequest(object_id);
    })
    .onCancel(() => { });
}

function _modalDialogConfirmRedirectByTimeoutDefaultRequest() {
  if (excute.value == true) {
    $q.dialog({
      title: `Tempo excedido`,
      message: `O seu tempo para realizar a tabulação foi excedido`,
      cancel: false,
      persistent: true,
      position: "bottom",
    }).onOk(() => {
      _recoveredTokenAndRedirectServiceHistory();
    });

    excute.value = false;
  }
}

function _recoveredTokenAndRedirectServiceHistory() {
  let token = localStorage.getItem("access_token");
  let link = `${window.location.origin}/service-history?access_token=${token}`;
  contract.dateStartedAttendance = "";
  window.location = link;
}

function _getDefaultTechnicianData() {
  contract.accredited = store.state.accredited;
  contract.numberPhone = store.state.numberPhone;
  contract.contractNumber =
    store.state.contractNumber === "string" ? "" : store.state.contractNumber;
  team.value = store.state.team;
  
  if (store.state.addressCity != "") {
    lowProductionServices
      .getCodeCityByName(store.state.addressCity)
      .then((response) => {        
        contract.codeCity = {
          text: response.cidade,
          value: response.codcidadenetsms,
        };
        contract.city = {
          text: response.cidade,
          value: response.codcidadenetsms,
        };
      }).catch((err) => {
        console.log(err);
      });
  }
  if (store.state.osDescription != "") {
    lowProductionServices
      .getTypeOsByName(store.state.osDescription)
      .then((response) => {
        for (let i = 0; i < contract.osRequests.length; i++) {
          contract.osRequests[i].typeOS = {
            text: response.tipo,
            value: response.id_tipoos,
          };
        }
      }).catch((err) => {
        console.log(err);
      });
  }
  if (store.state.numberPhone != "") {
    disableInputPhoneNumber.value = true;
  }
  if (store.state.accredited != "") {
    disableInputAccredited.value = true;
  }
}

function disableInputPhoneNumberFunction() {
  disableInputPhoneNumber.value = false;
}

function disableInputAccreditedFunction() {
  disableInputAccredited.value = false;
}

function checkIsOwnTechnician(newValue) {
  newValue == "TECNICO PROPRIO" 
  ? (contract.isOwnTechnician = true) 
  : (contract.isOwnTechnician = false);
}

computed(() => {
  setTimer(timerAttendance.minutes, timerAttendance.seconds);
});

const validateTime = (val) => {
  if (val && contract.initialTime && val === contract.conclusionTime){
    const startTimeInMinutes = timeToMinutes(contract.initialTime);
    const endTimeInMinutes = timeToMinutes(contract.conclusionTime);
    
    const isValid = validateConclusionTime(startTimeInMinutes, endTimeInMinutes);

    !isValid ? contract.conclusionTime = '' : null;
  }
};

onMounted(() => {
  _getCitiesActives();
  _getTypeOsActives();
  if (!isWriteOffByTypeAttendance.value) {
    _getWriteOffCodeActives();
  }
  _getAccreditedsActives();
  _createInitSchemaRequest();
  _getDefaultTechnicianData();
  _getAllActions();
  _getAllStateEquipaments();
  getLowTypes();


  if (isTypeAttendanceLowProduction.value) {
    getCityByCodeCity();
    getTypeOsByClassification();
  }
});
</script>

<style scoped lang="scss">
label {
  font-family: Roboto;
  font-style: normal;
}

.q-page-container {
  padding-bottom: 0px !important;
}

.label-checkbox-confirm {
  font-weight: 500 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  letter-spacing: 0.01em !important;
  color: #999999 !important;
}

footer {
  background: #ffffff;
  height: 12vh;

  .q-toolbar {
    height: 12vh;
  }

  .div-progress {
    height: 8vh;
  }

  .div-btn-next {
    height: 8vh;
  }
}

.section-service {
  .panel-services {
    background: transparent !important;
    overflow: hidden !important;

    .title-page {
      font-weight: bold;
      font-size: 18px;
      line-height: 19px;
      text-transform: uppercase;
      color: #e2262d;
    }

    .group-input {
      label {
        font-weight: bold;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.4);
      }
    }

    .label-requests-number {
      font-weight: 600;
      font-size: 15px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.5);
    }

    .label-requests-description {
      font-weight: 500;
      font-size: 12px;
      line-height: 20px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
</style>